import {computed, defineComponent} from 'vue';
import {Card} from 'primevue';

export default defineComponent({
    name: 'AegTestPaymentData',
    components: { Card },
    props: {},
    setup(props) {
        const showTestPaymentData: string = import.meta.env.VITE_SHOW_TEST_PAYMENT_DATA;

        const isVisible = computed((): boolean => { 
            return showTestPaymentData === 'true';
        });
        
        return {
            isVisible,
        };
    }
})
